import React, { useState, useEffect } from "react";
import { ProjectTypeType } from "types";
import "./project-type-block.scss";
import ProjectTypeHeader from "../project-type-header";
import ProjectTypeItem from "../project-type-item";

interface props {
  ProductType: ProjectTypeType;
  AddItemToTotal: any;
  contactsCount: number;
}

function ProjectTypeBlock({ ProductType, AddItemToTotal, contactsCount }: props) {
  const [projectType, setProjectType] = useState<ProjectTypeType>(ProductType);
  const [showCildren, setShowCildren] = useState<boolean>(false);

  useEffect(() => {}, [projectType]);

  return (
    <div style={{ cursor: "pointer" }}>
      <div className="projectTypeSection">
        <h3></h3>
        {projectType.IsHeader ? (
          <ProjectTypeHeader ProductType={projectType} setShowCildren={setShowCildren} showCildren={showCildren} />
        ) : (
          <ProjectTypeItem ProductType={projectType} setShowCildren={setShowCildren} showCildren={showCildren} AddItemToTotal={AddItemToTotal} contactsCount={contactsCount} />
        )}
        {projectType?.children.length >= 1 &&
          projectType.children.map((x) => (
            <div style={showCildren ? { display: "block", marginLeft: "20px" } : { display: "none", marginLeft: "20px" }}>
              <ProjectTypeBlock AddItemToTotal={AddItemToTotal} ProductType={x} contactsCount={contactsCount} />
            </div>
          ))}
      </div>
      <div className="optionsModal"></div>
    </div>
  );
}

export default ProjectTypeBlock;
